import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import TextTransition from "react-text-transition";

import { useDispatch } from "react-redux";
import { selectUserActivity, setUserActivity } from "../../redux/slices/userActivity";
import Searchbar from "../Searchbar";
import "./hero.css";
import useWindowDimensions from "../../hooks/useWindowDimensions";

//home page hero section
export default function Hero({ setheroOverlayActive }) {
  const searchbarRef = useRef(null);
  const [heroActive, setHeroActive] = useState(true);
  const [index, setIndex] = React.useState(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector((state) => state.user);
  const { width } = useWindowDimensions()

  const texts = ["Quizzes", "Games", "Puzzles", "Crosswords", "Many More Activities"];

  useEffect(() => {
    const intervalId = setInterval(
      () => setIndex((index) => index + 1),
      2000 // every 1.5 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);

  const handleScroll = () => {
    searchbarRef.current.scrollIntoView({ behavior: "smooth" });
    // window.scrollTo({ top: 400, left: 0, behavior: 'smooth' });
  };

  const handleSkip = () => {
    setheroOverlayActive(false);
    setHeroActive(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleSkip();
    }, 1000000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    dispatch(setUserActivity({ activities: [{}], defaultActivities: [{}] }));
    dispatch(selectUserActivity(0));
  }, []);

  return (
    <div className="hero" id={!heroActive ? "in-active" : ""}>
      <div className="row hero__columns">
        <div className="col-lg-6 d-flex align-items-center hero__column-left">
          <div>
            <div className="hero__messages">
              <h4 className="hero__message-top hero__message">
                {width > 1100 ?
                  'Create & Share' :
                  'Let’s Create'
                }
              </h4>
              <h4 className="hero__message-bottom hero__message">
                <TextTransition
                  //   style={{ textAlign: "center", marginLeft: "auto" }}
                  text={texts[index % texts.length]}
                  // springConfig={presets.molasses }
                  inline={false}
                />
              </h4>
            </div>
            <div className="hero__action-buttons">
              <button className="hero__action-button-left hero__action-button" onClick={handleScroll}>
                {" "}
                Explore{" "}
              </button>
              <Link to="/design"
              // target={isLoggedIn ? "" : "_blank"}
              >
                <button className="hero__action-button-right hero__action-button"> Start Creating </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="hero__logo">
          <img src="./assets/logo-white.png" />
        </div>
        <div className="col-lg-6 hero__column-right">
          <div className="hero__column-right__img_container">
            <img src="./assets/hero_img.png" className="hero_img" />

            <img src="./assets/glow-left1.svg" className="glow glow_left" />
            <img src="./assets/glow-right1.svg" className="glow glow_right" />
          </div>
        </div>
      </div>

      <div className="hero__scroll-down" ref={searchbarRef}>
        <img src="/assets/icons/scroll-down.svg" className="scroll__down-icon" />
        <p className="scroll__down-text">Scroll down</p>
      </div>
      <div className="hero__searchbar">
        <p className="hero__searchbar_text">Let’s Create </p>
        <Searchbar iconColor="black" />
      </div>

      <div className="hero__skip-btn" onClick={handleSkip}>
        <p>skip {">"}</p>
      </div>
    </div>
  );
}
